import React from 'react';
import { useDestination } from '../../routing/hooks';
import { useCodenameChangedHandler } from '../../adapters';
export default function SkipButton({ item }) {
    const destinationPaths = item.system.type === 'video_explainer_page'
        ? item.elements.linked_destinations.linkedItems
        : [];
    const destination = useDestination(destinationPaths);
    //this condition will need to be expanded to cover page types that don't allow skips
    const disabled = !destination;
    const changeCodename = useCodenameChangedHandler();
    const maybeAdvanceToDestination = () => {
        if (destination) {
            changeCodename(destination);
        }
    };
    return (React.createElement("button", { disabled: disabled, id: "skip", onClick: maybeAdvanceToDestination }, "Skip"));
}
//# sourceMappingURL=Skip.js.map